import { VehicleBuyInStatus } from "@/api-schema-enums";
import { Badge, BadgeColorVariant, BadgeVariant } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { VEHICLE_BUY_IN_STATUS_TRANSLATIONS } from "./vehicle-buy-in-status-translations";

interface VehicleBuyInStatusBadgeProps {
  status: VehicleBuyInStatus;
}

const VEHICLE_BUY_IN_STATUS_COLOR_VARIANTS = {
  [VehicleBuyInStatus.Unknown]: BadgeColorVariant.Secondary,
  [VehicleBuyInStatus.CreatingContract]: BadgeColorVariant.Warning,
  [VehicleBuyInStatus.ContractCreated]: BadgeColorVariant.Success,
  [VehicleBuyInStatus.SendingContract]: BadgeColorVariant.Warning,
  [VehicleBuyInStatus.ContractSent]: BadgeColorVariant.Success,
  [VehicleBuyInStatus.CancellingContract]: BadgeColorVariant.Warning,
  [VehicleBuyInStatus.ContractCancellationFailed]: BadgeColorVariant.Error,
  [VehicleBuyInStatus.ContractCompleted]: BadgeColorVariant.Success,
  [VehicleBuyInStatus.Completed]: BadgeColorVariant.Success,
  [VehicleBuyInStatus.V1SyncFailed]: BadgeColorVariant.Error,
  [VehicleBuyInStatus.Failed]: BadgeColorVariant.Error,
  [VehicleBuyInStatus.ContractDeclined]: BadgeColorVariant.Error,
  [VehicleBuyInStatus.ContractCancelled]: BadgeColorVariant.Error,
  [VehicleBuyInStatus.ContractExpired]: BadgeColorVariant.Warning,
} as const satisfies Record<VehicleBuyInStatus, BadgeColorVariant>;

export function VehicleBuyInStatusBadge({ status }: VehicleBuyInStatusBadgeProps) {
  const { t } = useTranslation("fab");
  const label = t(VEHICLE_BUY_IN_STATUS_TRANSLATIONS[status]);

  return (
    <Badge
      className="w-min text-center"
      variant={BadgeVariant.Outlined}
      colorVariant={VEHICLE_BUY_IN_STATUS_COLOR_VARIANTS[status]}
    >
      {label}
    </Badge>
  );
}
